<template>
  <CustomAutocomplete
    v-model="valueInput"
    :placeholder="placeholder"
    :title="title"
    :isRequired="isRequired"
    :disabled="disabled"
    :rules="rules"
    :loading="componentLoading"
    :returnObject="returnObject"
    :items="items"
    :isCassieSub="true"
    itemTextListTextIf="value"
    selectionTextIf="value"
    :expend-margin="expendMargin"
    :data-input-name="dataInputName"
    class="app-custom-input"
  />
</template>

<script>
import CustomAutocomplete from "./CustomAutocomplete.vue";
import { getVehicleDocsVelist } from "@/services/api/vehicle";

export default {
  name: "AppAutoCompleteVehicle",
  components: {
    CustomAutocomplete,
  },
  props: {
    value: {},
    placeholder: {
      type: String,
      default: "เลือก",
    },
    title: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    isCassieSub: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
    dataInputName: {
      type: String,
      default: "",
    },
    expendMargin: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      items: [],
      componentLoading: false,
    };
  },

  mounted() {
    this.getData();
  },

  computed: {
    valueInput: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    async getData() {
      this.componentLoading = true;
      const resp = await getVehicleDocsVelist(this.$store);
      if (resp["code"] === 200) {
        this.items = resp["data"];
      }
      // console.log("Vehicle Items", this.items);
      this.componentLoading = false;
    },
  },
};
</script>
<style></style>
